/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PurchasedCertificate model module.
 * @module model/PurchasedCertificate
 * @version 1.0
 */
class PurchasedCertificate {
    /**
     * Constructs a new <code>PurchasedCertificate</code>.
     * @alias module:model/PurchasedCertificate
     */
    constructor() { 
        
        PurchasedCertificate.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PurchasedCertificate</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PurchasedCertificate} obj Optional instance to populate.
     * @return {module:model/PurchasedCertificate} The populated <code>PurchasedCertificate</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PurchasedCertificate();

            if (data.hasOwnProperty('academic_program')) {
                obj['academic_program'] = ApiClient.convertToType(data['academic_program'], 'Number');
            }
            if (data.hasOwnProperty('certificate_code')) {
                obj['certificate_code'] = ApiClient.convertToType(data['certificate_code'], 'String');
            }
            if (data.hasOwnProperty('download_link')) {
                obj['download_link'] = ApiClient.convertToType(data['download_link'], 'String');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} academic_program
 */
PurchasedCertificate.prototype['academic_program'] = undefined;

/**
 * @member {String} certificate_code
 */
PurchasedCertificate.prototype['certificate_code'] = undefined;

/**
 * @member {String} download_link
 */
PurchasedCertificate.prototype['download_link'] = undefined;

/**
 * @member {String} created_at
 */
PurchasedCertificate.prototype['created_at'] = undefined;






export default PurchasedCertificate;

